import { render, staticRenderFns } from "./ThemaBeknopt.vue?vue&type=template&id=73ce7af4&"
import script from "./ThemaBeknopt.vue?vue&type=script&lang=js&"
export * from "./ThemaBeknopt.vue?vue&type=script&lang=js&"
import style0 from "./ThemaBeknopt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ThemaBeknopt.vue"
export default component.exports